import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';

import { TableChartConfigDto, BatterSingleSessionGameStatsChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import Table, { Order } from 'components/Table/Table';
import { getDisplayedColumns, tableHeaders } from 'utilities/tableHeaders';

export type BatterSingleSessionGameStatsChartColumn = keyof BatterSingleSessionGameStatsChartDataDto;

const BatterSingleSessionGameStatsChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<BatterSingleSessionGameStatsChartDataDto, TableChartConfigDto>) => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<BatterSingleSessionGameStatsChartColumn | '' | 'id'>('');

  const rows = useMemo(
    () =>
      chartData?.pitches
        ? [
            {
              ...chartData,
              id: '0',
            },
          ]
        : [],
    [chartData]
  );

  const columns = useMemo(() => {
    const displayedColumns = getDisplayedColumns<BatterSingleSessionGameStatsChartColumn>(chartConfig.visibleStats);

    return displayedColumns.map((column) => ({
      ...tableHeaders[column],
      field: column,
      headerName: t(column),
      headerShortName: t('short.' + column),
      sortable: true,
    }));
  }, [chartConfig.visibleStats]);

  return (
    <Table
      rows={rows}
      pageState={[page, setPage]}
      orderState={[order, setOrder]}
      orderByState={[orderBy, setOrderBy]}
      columns={columns}
      loading={isLoading}
      noFooter
      tileTable
      skeletonRows={1}
    />
  );
};

export default BatterSingleSessionGameStatsChart;
